import React from "react";

const Reasons = () => (
  <div className="flex justify-center lg:px-24 2xl:px-64 ">
    <div className="flex container px-8 flex-col md:flex-row md:items-center justify-center py-12 lg:py-24 w-full">
      <div className="flex flex-col w-full md:w-1/2 text-left md:mr-4">
        <h2 className="font-bold text-3xl lg:text-5xl text-gray-600 text-center lg:text-left">Cómo funciona Vivus: pasos sencillos para obtener tu préstamo</h2>{" "}
        <ul className="pt-12 relative pl-5">
          <li className="w-full border-green-light border-l md:px-20 pl-10 md:pl-20 px-0 pb-8">
            <span className="absolute text-green-light p-1 bg-white left-0 h-10 w-10 overflow-hidden flex justify-center items-center rounded-full border-green-light border-2">
              <strong>1</strong>
            </span>
            <strong className="text-xl text-gray-600">Completa tu solicitud</strong>
            <p>Llena la solicitud con tu información personal y financiera, te tomará pocos minutos. </p>
          </li>
          <li className="w-full border-green-light border-l  md:px-20 pl-10 md:pl-20 px-0 pb-8">
            <span className="absolute text-green-light p-1 bg-white left-0 h-10 w-10 overflow-hidden flex justify-center items-center rounded-full border-green-light border-2">
              <strong>2</strong>
            </span>
            <strong className="text-xl text-gray-600">Confirma tu identidad</strong>
            <p>Te pediremos que nos envíes una foto de tu Credencial para Votar expedida por el INE.</p>
          </li>
          <li className="w-full border-green-light border-l  md:px-20 pl-10 md:pl-20 px-0 pb-8">
            <span className="absolute text-green-light p-1 bg-white left-0 h-10 w-10 overflow-hidden flex justify-center items-center rounded-full border-green-light border-2">
              <strong>3</strong>
            </span>
            <strong className="text-xl text-gray-600">Recibe tu dinero</strong>
            <p>Una vez aprobada tu solicitud, recibirás el préstamo en tu cuenta en menos de 1 hora.*</p>
          </li>
          <li className="w-full md:px-20 pl-10 md:pl-20 px-0 pb-8">
            <span className="absolute text-green-light p-1 bg-white left-0 h-10 w-10 overflow-hidden flex justify-center items-center rounded-full border-green-light border-2">
              <strong>4</strong>
            </span>
            <div>
              <strong className="text-xl text-gray-600">Paga tu préstamo</strong>
            </div>
            <p className="como-p">Recibirás un recordatorio de pago antes de la fecha de tu vencimiento. Pagar es muy fácil y hay muchas opciones, </p>
            <div className="popup-link">
              <a
                href="/como-funciona?section=4"
                data-tip="1. En tiendas OXXO - Ingresa a tu perfil Vivus, crea un número de referencia para pago total o de parcialidad y paga con él en OXXO bajo la modalidad OXXO Pay. <br/> 2. Con tu tarjeta de débito - Ingresa a tu perfil vivus y paga total o parcialmente usando tu tarjeta de débito. <br/>3. Pago en cuenta bancaria - Realiza un depósito en cuenta bancaria a la cuenta de CI Banco 1633635, a nombre de INTEGRATED MANAGEMENT SERVICES MEXICO SA DE CV.<br/> No olvides poner tu número de crédito y nombre en la referencia."
                style={{ color: "#A3CD3A", display: "inline", cursor: "pointer" }}
              >
                conócelas aquí
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="flex flex-col items-start w-full md:w-1/2 md:ml-4">
        <div className="border-2 border-green-light py-12 relative flex flex-col">
          <div className="w-24 -top-6 -right-6 absolute p-4 bg-white">
            <img src="/img/landing/isotipo.svg" alt="isotipo" />
          </div>
          <div className="flex py-4 px-8 items-start">
            <img src="/img/efectigo-percent.svg" alt="percent" className="w-8" />
            <div className="reason-description">
              <p className="reason-title">Flexibilidad</p>
              <p>Si necesitas dinero adicional en tu préstamo, o quieres recorrer la fecha de pago de tu parcialidad, con Vivus es fácil hacerlo.</p>
            </div>
          </div>
          <div className="flex py-4 px-8 items-start">
            <img src="/img/efectigo-check.svg" alt="percent" className="w-8" />
            <div className="reason-description">
              <p className="reason-title">Empresa confiable</p>
              <p>Millones de personas ya utilizan nuestros servicios. Somos una de las empresas de préstamos más reconocidas en el mundo.</p>
            </div>
          </div>
          <div className="flex py-4 px-8 items-start">
            <img src="/img/efectigo-head.svg" alt="percent" className="w-8" />
            <div className="reason-description">
              <p className="reason-title">Soporte local</p>
              <p>¡Lo más importante en Vivus eres tú! Por lo que nuestro equipo está siempre listo para ayudarte.</p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="dotted-ball">
            <img src="/img/dotted-ball.svg" alt="dotted"/>
        </div> */}
      {/* <div className="green-ball">
            <img src="/img/green-ball.svg" alt="dotted"/>
        </div>   */}
    </div>
  </div>
);

export default Reasons;
